import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCoreValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const values = [{
    number: "1",
    title: "Simplicity",
    description: "We believe in clearing the clutter to find peace. A simplified home leads to a clearer mind, creating room for what truly matters in your daily life."
  }, {
    number: "2",
    title: "Functionality",
    description: "Every item should have a purpose and a place. We design intuitive systems that work for you, making maintenance effortless and sustainable."
  }, {
    number: "3",
    title: "Warmth",
    description: "Organized spaces should feel lived-in, not sterile. We blend structure with softness to create a welcoming environment that feels authentically yours."
  }];
  return <section id="our-core-values" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("border border-[var(--border)] rounded-[2rem] p-10 md:p-20 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 text-center">
            {values.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-center group">
                <span className="font-serif text-7xl md:text-8xl text-[var(--chart-1)] mb-6 block leading-none select-none">
                  {item.number}
                </span>
                <h3 className="font-serif text-3xl text-foreground mb-4 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto text-lg">
                  {item.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}